import withLocalLoader from 'components/HOCs/withLocalLoader';
import LeadPartnersPage from './LeadPartnersPage';

export default withLocalLoader(
  LeadPartnersPage,
  true,
  'Marketing Services',
  'Leads'
);
